<!--
 * @Author: zhanghan
 * @Date: 2021-01-23 21:55:45
 * @LastEditors: zhanghan
 * @LastEditTime: 2022-06-27 10:29:03
 * @Descripttion:
-->
<template>
  <div class="BAllBlog">
    <div class="allBlogContent">
      <v-article
        :articleList="articleList"
        :articleCount="articleCount"
        :currentPage="currentPageCopy"
        :pageNum="pageNum"
        :isLoading="isLoading"
        :toEdit="true"
        :isArticle="true"
        @getCategories="getCategories"
        @showMessage="showMessage"
      ></v-article>
    </div>
  </div>
</template>

<script>
import Article from "@/components/common/article/article";
export default {
  components: {
    "v-article": Article
  },
  data() {
    return {
      currentPageCopy: this.currentPage,
      scrollEl: ""
    };
  },
  props: {
    articleList: {
      type: Array,
      default: () => []
    },
    articleCount: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pageNum: {
      type: Number,
      default: 20
    },
    userInfo: {
      type: Object,
      default: {}
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    currentPage(newVal) {
      this.currentPageCopy = newVal;
    }
  },
  mounted() {
    this.scrollEl = document.getElementById("BAMCom");
    //添加鼠标滚动事件
    this.scrollEl.addEventListener("scroll", this.onScroll);
  },
  destroyed() {
    //删除鼠标滚动事件
    this.scrollEl.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    // 获取滚动条当前的位置
    getScrollTop() {
      return this.scrollEl.scrollTop;
    },
    // 获取当前可视范围的高度
    getClientHeight() {
      var clientHeight = 0;
      if (document.body.clientHeight && document.documentElement.clientHeight) {
        clientHeight = Math.min(
          document.body.clientHeight,
          document.documentElement.clientHeight
        );
      } else {
        clientHeight = Math.max(
          document.body.clientHeight,
          document.documentElement.clientHeight
        );
      }
      return clientHeight;
    },
    // 获取文档完整的高度
    getScrollHeight() {
      return this.scrollEl.scrollHeight;
    },
    // 滚动事件触发下拉加载
    onScroll() {
      //满足滚动条底部触发获取文章列表
      if (
        this.getScrollHeight() - this.getClientHeight() - this.getScrollTop() <=
        0
      ) {
        let allPageNum = Math.ceil(this.articleCount / this.pageNum);
        //判断文章列表加载状态用来防止重复触发请求
        if (!this.isLoading && this.currentPageCopy < allPageNum) {
          //不是加载状态且当前页小于总页数，才允许加载文章列表数据
          // 页码，分页用，默认第一页
          this.currentPageCopy++;
          // 请求列表数据
          this.getArticleList({
            currentPage: this.currentPageCopy,
            pageNum: this.pageNum
          });
        }
      }
    },
    getCategories() {
      this.$emit("getCategories");
    },
    clearArticleList() {
      this.$emit("clearArticleList");
    },
    getArticleList(data) {
      this.$emit("getArticleList", data);
    },
    showMessage(msg) {
      this.$emit("showMessage", msg);
    }
  }
};
</script>

<style lang="less" scoped>
.BAllBlog {
  padding-top: 30px;
  padding-left: 200px;
  .article {
    margin: auto;
    width: 70%;
  }
}
@media (max-width: 1024px) {
  .BAllBlog {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 50px;
    padding: 0;
    width: 100%;
    padding-top: unset;
    padding-left: unset;
    .allBlogContent {
      .article {
        width: 100%;
        .info {
          display: none;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// allBlog.vue?1cbe3531